import React from 'react';
import { Container, Paper } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';
import ExportReport from '../../components/ExportReport';

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(1)
  }
}));

const Reports = () => {
  const classes = useStyles();

  return (
    <Container component="main" maxWidth="md" className={classes.container}>
      <CssBaseline />
      <Paper>
        <ExportReport />
      </Paper>
    </Container>
  );
};

export default Reports;
